import { useMemo, useState } from "react";
import "./transaction.css";
import CardCustom from "../../components/card";
import { TableCustomProps } from "../../components/table/table";
import { LottiesComponent } from "../../components/loadingLotties/LottiesComponent";
import cardLottie from "../../assets/lottie/target.json";
import TableMaterial from "../../components/tableMaterial/tableMaterial";
import ButtonUI from "../../components/button/buttons";
import useFetchProfiles from "../../service/profileService/profileService";
import SettingsIcon from "@mui/icons-material/Settings";
import { UserSetting } from "./userSettings/userSetting";
import PersonIcon from "@mui/icons-material/Person";
import { Box, Typography } from "@mui/material";
import { useGetProfiles } from "../../service/profilesService/getProfile";

const Users = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endStarDate, setEndStartDate] = useState<Date | null>(null);
  const [selectedTransaction, setSelectTransaction] = useState<null>(null);

  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState<string>("");
  const [searchClicked, setSearchClicked] = useState(false);

  const handleOpenModal = (transaction: any) => {
    setOpenModal(true);
    setSelectTransaction(transaction);
    // setOpenModal(true);
  };

  const transformDataToTable = (
    transactions: any[]
  ): TableCustomProps["rows"] => {

    return transactions?.map((transaction) => ({
      name: (
        <Box sx={{ display: "flex" }}>
          <PersonIcon />
          <Typography>
            {transaction?.first_name && transaction?.last_name
              ? `${transaction.first_name} ${transaction.last_name}`
              : "Falta Completar perfil"}
          </Typography>
        </Box>
      ),
      user: transaction?.user,
      phone: transaction?.phone,
      email: transaction?.email,
      updated_at: new Date(transaction?.updated_at).toLocaleDateString(
        "es-MX",
        {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZone: "America/Mexico_City",
        }
      ),
      create_at: new Date(transaction?.created_at).toLocaleDateString("es-MX", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Mexico_City",
      }),
      // status: (
      //   <div className={`status ${transaction.status.toLowerCase()}`}>
      //     {translateStatus(transaction.status)}
      //   </div>
      // ),

      info: (
        <div>
          <ButtonUI
            icon={<SettingsIcon />}
            variant="text"
            onClick={() => handleOpenModal(transaction)}
          />
        </div>
      ),
    }));
  };


  const { data, isLoading, error } = useGetProfiles({
    email: email || undefined,
    page: page,
    pageSize: 10,
    status: 'ALL',
  })


  const dataTable: any = {
    columns: [
      { id: "name", label: "Nombre de usuario" },
      // { id: "user", label: "AUTH0" }, comentado en caso de necesitarlo a futuro
      { id: "phone", label: "Teléfono" },
      { id: "email", label: "Correo" },
      { id: "updated_at", label: "Actualización" },
      { id: "create_at", label: "Fecha de Registro" },
      { id: "info", label: "Gestionar" },
    ],
    rows: transformDataToTable(data?.data),
  };



  const onChangeEmail = (e: any) => {
    setEmail(e.target.value);
  };

  const handleSearchClick = () => {
    setSearchClicked((prev) => !prev);
  };

  return (
    <div>

      <CardCustom classCustom="activity_card">
        {!selectedTransaction && (
          <>
            <h2>Usuarios</h2>
            <p>
              Esta sección te permite gestionar a todos los usuarios
              registrados en nuestra plataforma. Aquí podrás ver, editar y
              eliminar cuentas.
            </p>
          </>
        )}
        {selectedTransaction ? (
          <UserSetting
            data={selectedTransaction}
            stateSelect={setSelectTransaction}
            onDeleted={() => {
              setSelectTransaction(null);
              setSearchClicked((prev) => !prev);
            }}
          />
        ) : (
          <TableMaterial
            valueInput={email}
            onClickSearch={handleSearchClick}
            onChangeInput={onChangeEmail}
            setEndDate={setEndStartDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endStarDate}
            setPage={setPage}
            page={page}
            totalRows={data?.pagination?.countData}
            setRowsPerPage={setRowsPerPage}
            rowsPerPage={rowsPerPage}
            columns={dataTable.columns}
            rows={dataTable?.rows || []}
            loading={isLoading}
          />
        )}
      </CardCustom>


    </div>
  );
};

export default Users;
